module.exports = __webpack_public_path__ + "img/27_13.91f8fe02.png";